import { useTranslation } from 'react-i18next'
import { Button, H3, Text } from '@/components/atoms'
import { IdCard } from '@/components/molecules'
import { rentersDefaultIdCardImage } from '@/shared/assets'
import { useRentersStepOnePage } from './page.onboarding-renters-step-one.hook'

interface RentersStepOnePageProps {
  policyId: string
  dwellingType: string
  startAt: string
  ownerName: string
  isLoading?: boolean
  onContinue: () => void
}

export function RentersStepOnePage({
  policyId,
  dwellingType,
  startAt,
  ownerName,
  isLoading = false,
  onContinue,
}: RentersStepOnePageProps) {
  const { t } = useTranslation()
  const { handleContinue } = useRentersStepOnePage({ onContinue })

  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-col gap-4 overflow-y-auto pb-4 md:flex-row-reverse md:justify-between md:gap-10 md:pb-0">
        <IdCard
          variant="with-photo"
          photoUrl={rentersDefaultIdCardImage}
          planName={dwellingType}
          ownerName={ownerName}
          policyId={policyId}
          startDate={startAt}
          isLoading={isLoading}
          className="align-self-center hidden aspect-326/206 md:block md:max-h-51.5 md:max-w-81.5 md:shrink-0"
          isMobile={false}
          hidePhotoBackground
        />
        <div className="flex flex-col gap-4 md:max-w-95 md:gap-6">
          <H3 className="text-neutral-900">
            {t('onboarding.renters.modalTitle')}
          </H3>
          <Text className="text-sm text-neutral-900 md:text-base">
            {t('onboarding.renters.modalDescription')}
          </Text>
        </div>
      </div>
      <div className="mt-auto flex w-full gap-3 pt-4 md:pt-0">
        <Button
          onClick={handleContinue}
          className="h-12 w-full md:mb-2.5 md:w-auto"
          data-testid="step-one-continue"
        >
          {t('onboarding.continue')}
        </Button>
      </div>
    </div>
  )
}
